<template>
  <div v-if="!loading">
    <form>
      <v-card
        v-if="form.spracovatelia"
        class="my-5"
      >
        <v-card-title>
          Spracovatelia ZVJS
          <v-spacer />
          <v-btn
            icon
            @click="showInfo('spracovatelia_zvjs')"
          >
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(input, index1) in form.spracovatelia"
            :key="input.id"
            dense
          >
            <v-col>
              <v-autocomplete
                v-model="input.user"
                :disabled="form.closed"
                item-text="string_details"
                item-value="id"
                placeholder="Používateľ"
                label="Používateľ"
                :items="items_administrator[index1]"
                auto-select-first
                :search-input.sync="search_administrator[index1]"
                cache-items
                :loading="loading_administrator[index1]"
                hide-no-data
                append-icon="mdi-delete"
                @click:append="deleteRowSpracovatel(index1)"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.type"
                :items="select_administrator"
                label="Typ"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.pracovna_pozicia"
                :items="select_pracovna_pozicia"
                label="Pracovná pozícia"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="input.miesto"
                label="Miesto"
              />
            </v-col>
          </v-row>

          <v-btn
            text
            icon
            color="secondary"
            @click="addRow()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <v-card
        v-if="form.spracovatelia_upsvar"
        class="my-5"
      >
        <v-card-title>
          Spracovatelia ÚPSVaR
          <v-spacer />
          <v-btn
            icon
            @click="showInfo('spracovatelia_upsvar')"
          >
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(input, index1) in form.spracovatelia_upsvar"
            :key="input.id"
            dense
          >
            <v-col>
              <v-autocomplete
                v-model="input.user"
                :disabled="form.closed"
                item-text="string_details"
                item-value="id"
                placeholder="Používateľ"
                label="Používateľ"
                :items="items_administrator_upsvar[index1]"
                auto-select-first
                :search-input.sync="search_administrator_upsvar[index1]"
                cache-items
                :loading="loading_administrator_upsvar[index1]"
                hide-no-data
                append-icon="mdi-delete"
                @click:append="deleteRowSpracovatelUPSVAR(index1)"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.type"
                :items="select_administrator_upsvar"
                label="Typ"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.pracovna_pozicia"
                :items="select_pracovna_pozicia"
                label="Pracovná pozícia"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="input.miesto"
                label="Miesto"
              />
            </v-col>
          </v-row>

          <v-btn
            text
            icon
            color="secondary"
            @click="addRowUPSVAR()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          class="ma-2"
          fixed
          right
          bottom
          dark
          rounded
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-text>
            <p
              v-for="priklad in dialog_item.priklady"
              :key="priklad.nazov"
            >
              {{ priklad }}
            </p>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Spracovatelia" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";

const apiService = new APIService();

export default {

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: [],
    },


    loading_administrator: [],
    search_administrator: [],

    loading_administrator_upsvar: [],
    search_administrator_upsvar: [],

    watchers: [],
    watchers_upsvar: [],

    form: {
      id: null,
    },
    items_administrator: [],
    items_administrator_upsvar: [],

    select_administrator: [
      { value: "Administrátor", text: "Administrátor" },
      { value: "Spracovateľ", text: "Spracovateľ" },
      { value: "Externý spracovateľ", text: "Externý spracovateľ" },
    ],

    select_administrator_upsvar: [
      { value: "ÚPSVaR - administrátor", text: "ÚPSVaR - administrátor" },
      { value: "ÚPSVaR - spracovateľ", text: "ÚPSVaR - spracovateľ" },
    ],

    select_pracovna_pozicia: [
      "Sociálny pracovník",
      "Psychológ",
      "Pedagóg",
      "Sociálny kurátor - metodik",
      "Sociálny kurátor - ÚPSVAR",
    ],

    select_pracovna_pozicia_upsvar: [
      "ÚPSVaR - vedúci",
      "ÚPSVaR - kurátor",
    ],

    manual: {
      spracovatelia_zvjs: {
        nazov: "Spracovatelia ZVJS",
        priklady: [
          "Táto sekcia slúži na definovanie prístupových práv pre používateľov z prostredia ZVJS.",
          "Používateľ a typ sú povinné položky, pracovná pozícia a miesto sú nepovinné položky a slúžia na uľahčenie správy pri veľkom počte spracovateľov.",
          "Typ Administrátor: Správa spracovateľov a kompletný prístup ku všetkým položkám formuláru",
          "Typ Spracovateľ: Kompletný prístup ku všetkým položkám formuláru",
          "Typ Externý spracovateľ: Prístup k vybraným položkám formuláru (bez základného čísla a obmedzení)"
        ]
      },
      spracovatelia_upsvar: {
        nazov: "Spracovatelia ÚPSVaR",
        priklady: [
          "Táto sekcia slúži na definovanie prístupových práv pre používateľov z prostredia ÚPSVaR.",
          "Používateľ a typ sú povinné položky, pracovná pozícia a miesto sú nepovinné položky a slúžia na uľahčenie správy pri veľkom počte spracovateľov.",
          "Typ ÚPSVaR - administrátor: Správa spracovateľov a kompletný prístup ku všetkým položkám formuláru (v kontexte zmluvy o spolupráci)",
          "Typ ÚPSVaR - spracovateľ: Kompletný prístup ku všetkým položkám formuláru (v kontexte zmluvy o spolupráci)"
        ]
      },
    }
  }),

  watch: {},

  mounted() {
    this.getItem();
  },

  methods: {
    showInfo(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    updateWatchersAnd() {

      if (this.form.spracovatelia) {
        for (let i = 0; i < this.form.spracovatelia.length; i++) {
          this.loading_administrator.push(false);
          this.search_administrator.push("");
          this.items_administrator.push([]);

          this.items_administrator[i].push(this.form.spracovatelia[i].user_full);
        }

        this.search_administrator.forEach((index, val) => {
          let unwatch = this.$watch(
            ["search_administrator", val].join("."),
            (newVal) => {
              this.querySelectionsAdministrator(newVal, val);
            }
          );
          this.watchers.push(unwatch);
        });
      }

      if (this.form.spracovatelia_upsvar) {

        for (let i = 0; i < this.form.spracovatelia_upsvar.length; i++) {
          this.loading_administrator_upsvar.push(false);
          this.search_administrator_upsvar.push("");
          this.items_administrator_upsvar.push([]);

          this.items_administrator_upsvar[i].push(this.form.spracovatelia_upsvar[i].user_full);
        }

        this.search_administrator_upsvar.forEach((index, val) => {
          let unwatch = this.$watch(
            ["search_administrator_upsvar", val].join("."),
            (newVal) => {
              this.querySelectionsAdministratorUPSVAR(newVal, val);
            }
          );
          this.watchers_upsvar.push(unwatch);
        });

      }
    },

    getItem() {
      this.loading = true;
      apiService.getIapszForm(this.$route.params.id).then((response) => {
        this.form = response;
        this.updateWatchersAnd();
        this.loading = false;
      });
    },

    updateItem() {
      apiService.updateIapszForm(this.form, this.$route.params.id).then(
        (response) => {
          this.snackbar_saved = true;
          this.form = response;
          this.updateWatchersAnd();
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    addRow() {
      this.loading_administrator.push(false);
      this.search_administrator.push("");
      this.items_administrator.push([]);

      this.form.spracovatelia.push({
        user: null,
        iapsz: this.$route.params.id,
        type: null,
      });

      let index = this.search_administrator.length - 1;

      this.watchers.push(
        this.$watch(["search_administrator", index].join("."), (newVal) => {
          this.querySelectionsAdministrator(newVal, index);
        })
      );
    },

    addRowUPSVAR() {
      this.loading_administrator_upsvar.push(false);
      this.search_administrator_upsvar.push("");
      this.items_administrator_upsvar.push([]);

      this.form.spracovatelia_upsvar.push({
        user: null,
        iapsz: this.$route.params.id,
        type: null,
      });

      let index = this.search_administrator_upsvar.length - 1;

      this.watchers_upsvar.push(
        this.$watch(["search_administrator_upsvar", index].join("."), (newVal) => {
          this.querySelectionsAdministratorUPSVAR(newVal, index);
        })
      );
    },


    deleteRowSpracovatel(index) {
      for (let i = 0; i < this.watchers.length; i++) {
        this.watchers[i]();
      }
      this.watchers = [];

      this.form.spracovatelia.splice(index, 1);
      this.loading_administrator.splice(index, 1);
      this.items_administrator.splice(index, 1);
      this.search_administrator.splice(index, 1);

      this.search_administrator.forEach((index, val) => {
        let unwatch = this.$watch(
          ["search_administrator", val].join("."),
          (newVal) => {
            this.querySelectionsAdministrator(newVal, val);
          }
        );

        this.watchers.push(unwatch);
      });
    },

    deleteRowSpracovatelUPSVAR(index) {
      for (let i = 0; i < this.watchers_upsvar.length; i++) {
        this.watchers_upsvar[i]();
      }
      this.watchers_upsvar = [];

      this.form.spracovatelia_upsvar.splice(index, 1);
      this.loading_administrator_upsvar.splice(index, 1);
      this.items_administrator_upsvar.splice(index, 1);
      this.search_administrator_upsvar.splice(index, 1);

      this.search_administrator_upsvar.forEach((index, val) => {
        let unwatch = this.$watch(
          ["search_administrator_upsvar", val].join("."),
          (newVal) => {
            this.querySelectionsAdministratorUPSVAR(newVal, val);
          }
        );

        this.watchers_upsvar.push(unwatch);
      });
    },

    querySelectionsAdministrator(v, index) {
      this.loading_administrator[index] = true;

      apiService.searchUsers(v).then((response) => {
        this.items_administrator[index] = response.results;
        this.loading_administrator[index] = false;
      });
    },

    querySelectionsAdministratorUPSVAR(v, index) {
      this.loading_administrator_upsvar[index] = true;

      apiService.searchUsers(v).then((response) => {
        this.items_administrator_upsvar[index] = response.results;
        this.loading_administrator_upsvar[index] = false;
      });
    },
  },
};
</script>